import React from 'react';
import {
    CircleIcon,
    RoadDetails,
    RoadDetailsContainer,
    RoadDetailsWrapper,
    RoadLogoWrapper,
    ProgressIcon,
    RowItem,
    TimeWrapper
} from "./styles";
import {StyledParagraph, StyledText, StyledTitle} from "../CustomAntdComponents/Typography";
import {ReactComponent as BusIcon} from "../../assets/images/bus-grey.svg";
import {getRoadTransportLogo} from "../AvailableBuses/helper";
import moment from "moment";

type Props = {
    operator: BusResultItem,
    bus: AvailableBus,
}

const RoadCard = ({ operator, bus }: Props) => {
    const formatItineraryTime = (dateStr: string, fallbackTime: string) => {
        if (!dateStr) return fallbackTime;
        const m = moment(dateStr);
        return m.isValid() ? m.format("hh:mm a") : fallbackTime;
    };

    const depTime = formatItineraryTime(bus.EstimatedDepartureDate, bus.EstimatedDepartureTime);
    const arrTime = formatItineraryTime(bus.EstimatedArrivalDate, bus.EstimatedArrivalTime);

    const showBoarding = bus.BoardingDetails && 
                         bus.BoardingDetails.Name && 
                         bus.BoardingDetails.Name !== operator.DepartureTerminal && 
                         bus.BoardingDetails.Name.toLowerCase() !== "null";

    const showDropOff = bus.DropOffDetails && 
                        bus.DropOffDetails.Name && 
                        bus.DropOffDetails.Name !== operator.ArrivalTerminal && 
                        bus.DropOffDetails.Name.toLowerCase() !== "null";

    const formattedDuration = bus.Duration ? bus.Duration.replace(':', ' ') : '';

    return (
        <RoadDetailsContainer>
            <RoadDetails>
                <RowItem>
                    <TimeWrapper>
                        <StyledTitle level={5} style={{ fontWeight: 500 }}>
                            {depTime}
                        </StyledTitle>
                    </TimeWrapper>

                    <ProgressIcon>
                        <CircleIcon />
                    </ProgressIcon>

                    <RoadDetailsWrapper>
                        <StyledParagraph size="large" style={{ fontWeight: 600, color: '#15162B' }}>
                            {operator.DepartureTerminal}
                        </StyledParagraph>
                        {showBoarding && (
                            <StyledParagraph style={{ color: '#72737F' }}>
                                {bus.BoardingDetails.Name}
                            </StyledParagraph>
                        )}
                    </RoadDetailsWrapper>
                </RowItem>

                <RowItem>
                    <TimeWrapper>
                        <StyledParagraph align="center" style={{ color: '#72737F' }}>
                            {formattedDuration}
                        </StyledParagraph>
                    </TimeWrapper>

                    <ProgressIcon road>
                        <BusIcon width={15} height={15} />
                    </ProgressIcon>

                    <RoadDetailsWrapper>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <RoadLogoWrapper>
                                <img
                                    src={bus.Operator?.Logo || getRoadTransportLogo(operator.AgentName)}
                                    alt={bus.Operator?.Name || operator.AgentName}
                                />
                            </RoadLogoWrapper>

                            <StyledText style={{ fontWeight: 500, color: '#15162B' }}>
                                {bus.Operator?.Name || operator.AgentName}
                            </StyledText>
                        </div>
                        <StyledParagraph size="small" style={{ color: '#72737F', marginTop: '4px' }}>
                            {bus.BusType} | {`${bus.Capacity} seater`}
                        </StyledParagraph>
                    </RoadDetailsWrapper>
                </RowItem>

                <RowItem>
                    <TimeWrapper>
                        <StyledTitle level={5} style={{ fontWeight: 500 }}>
                            {arrTime}
                        </StyledTitle>
                    </TimeWrapper>

                    <ProgressIcon>
                        <CircleIcon />
                    </ProgressIcon>

                    <RoadDetailsWrapper>
                        <StyledParagraph size="large" style={{ fontWeight: 600, color: '#15162B' }}>
                            {operator.ArrivalTerminal}
                        </StyledParagraph>
                        {showDropOff && (
                            <StyledParagraph style={{ color: '#72737F' }}>
                                {bus.DropOffDetails.Name}
                            </StyledParagraph>
                        )}
                    </RoadDetailsWrapper>
                </RowItem>
            </RoadDetails>

        </RoadDetailsContainer>
    );
};

export default RoadCard;
